
export const order_key = {
    gift_carts: 'gift_carts',
    pickup_store: 'pickup_store',
    latest_order_address: 'latest_order_address',
    order_carts: 'order_carts',
    order_status: 'order_status',
}
export function setOrderCache(key,value,isString){
    // console.log('key=======',key)
    // console.log('value=======',value)
     try{
         if(!isString)
         value = JSON.stringify(value);
 
   //  console.log('value1=======',value)
     localStorage.setItem(key, value);
     }
     catch(ex){
         console.log("save data to local storage for order exception:",ex);
     }
 
 }
 
 export function getOrderCache(key,isString){
     try{
         var value = localStorage.getItem(key);
         if(value && !isString){
             value = JSON.parse(value);
             
         }
         return value;
     }
     catch(ex){
         console.log("get data to local storage for order exception:",ex);
         return null;
     }
 }

export async function addItemToCart(itemTobeAdded){
    var cartExisting = getOrderCache(order_key.gift_carts);
    var newCart = [];
    var total = 0;
    if(!cartExisting || cartExisting.length == 0){
        newCart.push(itemTobeAdded);
        total = itemTobeAdded.quantity;
    }else{
        var isExit = false;
        cartExisting.forEach(item => {
            total = total + item.quantity 
            if (item.id === itemTobeAdded.id) {
                isExit = true;
                item.quantity = item.quantity + itemTobeAdded.quantity;
                total = total + itemTobeAdded.quantity 
            }
            newCart.push(item);
        });
        if (!isExit) {
            total = total + itemTobeAdded.quantity 
            newCart.push(itemTobeAdded);
        }
    }
    //console.log('newCarrt===', newCart)
    setOrderCache(order_key.gift_carts,newCart)
    return total;
}

export async function removeFromCart(itemToRemove){
    var cart = getOrderCache(order_key.gift_carts);
    var newCart = cart.filter(item => {
        return item.guid != itemToRemove.guid
    })
    setOrderCache(order_key.gift_carts,newCart)
}

export async function clearCart(){
    setOrderCache(order_key.gift_carts,[])
}

export function setOrderStatusCache(key, value, isString) {
    try {
        if (!isString)
            value = JSON.stringify(value);
        localStorage.setItem(key, value);
    }
    catch (ex) {
        console.log("save data to local storage for order status exception:", ex);
    }

}

export function getOrderStatusCache(key, isString) {
    try {
        var value = localStorage.getItem(key);
        if (value && !isString) {
            value = JSON.parse(value);
        }
        return value;
    }
    catch (ex) {
        console.log("get data to local storage for order status exception:", ex);
        return null;
    }
}

